import { r as registerInstance, h, H as Host, g as getElement } from './index-6f037ff9.js';

const cookiesBannerCss = "@charset \"UTF-8\";:host{--_cookies-banner-bg-color:var(--cookies-banner-bg-color);--_cookies-banner-box-shadow:var(--cookies-banner-box-shadow);--_cookies-banner-text-color:var(--cookies-banner-text-color);--_cookies-banner-link-color:var(--cookies-banner-link-color)}:host{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:center;justify-content:center;position:-webkit-sticky;position:sticky;bottom:0rem;z-index:999}:host .banner-container{background-color:var(--_cookies-banner-bg-color);-webkit-box-shadow:var(--_cookies-banner-box-shadow);box-shadow:var(--_cookies-banner-box-shadow);display:-ms-flexbox;display:flex;padding:2.5rem 4rem;-ms-flex-direction:column;flex-direction:column;-ms-flex-pack:end;justify-content:flex-end;-ms-flex-align:start;align-items:flex-start;gap:2rem;opacity:0;height:0}:host .banner-container.show-banner{height:auto;opacity:1;-webkit-transition:opacity 0.3s ease-in 0.2s;transition:opacity 0.3s ease-in 0.2s}:host .banner-container.remove-banner{opacity:0;-webkit-transition:opacity 0.3s ease-out;transition:opacity 0.3s ease-out}:host .banner-container .text-container{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;-ms-flex-align:start;align-items:flex-start;gap:0.5rem;-ms-flex-item-align:stretch;align-self:stretch;font-style:normal;color:var(--_cookies-banner-text-color)}:host .banner-container .text-container .title-text{font-size:1.5rem;font-weight:600;line-height:141.667%;letter-spacing:0.0018125rem}:host .banner-container .text-container .info-text-container{font-size:1rem;letter-spacing:0.0011875rem}@media (max-width: 767px){:host .banner-container .text-container .info-text-container{width:100%}}@media (min-width: 768px){:host .banner-container .text-container .info-text-container{width:83%}}@media (min-width: 1440px){:host .banner-container .text-container .info-text-container{width:66%}}:host .banner-container .text-container .info-text-container .info-text{font-weight:400;line-height:162.5%}:host .banner-container .buttons-container{display:-ms-flexbox;display:flex;width:100%;-ms-flex-align:end;align-items:flex-end;-ms-flex-wrap:wrap;flex-wrap:wrap;gap:1.5rem}:host ::slotted([slot=link]){color:var(--_cookies-banner-link-color) !important;font-weight:700;line-height:1.625rem;-webkit-text-decoration-line:underline;text-decoration-line:underline}:host ::slotted([slot$=-button]){display:contents}";

const CookiesBanner = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.theme = 'primary';
    this.buttonsVariant = 'cookies';
    this.fullWidth = false;
    this.isShowBanner = false;
    this.waitRemove = 300; //Tiempo de transición al cerrar el banner
    this.consentCookieName = 'hasConsent'; //nombre de la cookie de consentimiento
    this.consentCookieTimeout = 60 * 60 * 24 * 365 * 1000 * 2; // tiempo máximo duración cookies de 2 años en milisegundos
    this.bots = /bot|crawler|spider|crawling/i;
  }
  handleResize() {
    const screenSize = window.innerWidth;
    (screenSize > 480 && this.buttonsVariant !== 'cookies') || (screenSize > 704 && this.buttonsVariant === 'cookies') ? (this.fullWidth = false) : (this.fullWidth = true);
    const buttons = this.bannerElement.querySelectorAll('imv-ui-button');
    buttons.forEach((button) => {
      button.fullWidth = this.fullWidth;
    });
  }
  async acceptCookies() {
    this.removeBanner(this.waitRemove);
    this.setConsentCookie('true');
  }
  async rejectCookies() {
    this.removeBanner(this.waitRemove);
    this.setConsentCookie('false');
  }
  componentDidLoad() {
    this.handleResize();
    this.addLinkStopPropagation();
    this.init();
  }
  addLinkStopPropagation() {
    const link = this.bannerElement.querySelector('a');
    link.addEventListener('click', e => e.stopPropagation());
  }
  init() {
    // Detecta si el visitante es un bot o no. Evita que los buscadores tomen el mensaje de alerta de cookies como contenido principal de la página.
    const isBot = this.bots.test(navigator.userAgent);
    // Chequea si DoNotTrack está activado
    const dnt = navigator.doNotTrack;
    const isToTrack = dnt !== null && dnt !== undefined ? dnt && dnt !== 'yes' && dnt !== 1 && dnt !== '1' : true;
    // No hacer nada si es un bot, si DoNotTrack está activado, tampoco hacer nada
    if (isBot || !isToTrack || this.hasConsent() === false) {
      this.removeBanner(0);
      return false;
    }
    // Si el usuario ya ha dado el consentimiento de cookies, emite la función de lanzar cookies personalizadas desde la aplicación
    if (this.hasConsent() === true) {
      this.removeBanner(0);
      return true;
    }
    // Si no es un bot, no DoNotTrack y todavía no ha aceptado, establece la cookie de consentimiento a pendiente y muestra el banner
    this.setConsentCookie('pending');
    this.showBanner();
  }
  setConsentCookie(isConsented) {
    this.setCookie(this.consentCookieName, isConsented);
  }
  hasConsent() {
    let cookieName = this.consentCookieName;
    let isCookieSetTo = (value) => {
      return document.cookie.indexOf(cookieName + '=' + value) > -1;
    };
    if (isCookieSetTo('true')) {
      return true;
    }
    else if (isCookieSetTo('false')) {
      return false;
    }
    return null;
  }
  setCookie(name, value) {
    let date = new Date();
    date.setTime(date.getTime() + this.consentCookieTimeout);
    document.cookie = name + '=' + value + ';expires=' + date.toUTCString() + ';path=/' + ';secure;SameSite=Lax';
  }
  showBanner() {
    this.isShowBanner = true;
  }
  removeBanner(wait) {
    this.bannerContainer.classList.add('remove-banner');
    setTimeout(() => {
      const bannerParent = this.bannerElement.parentNode;
      if (bannerParent) {
        bannerParent.removeChild(this.bannerElement);
      }
    }, wait);
  }
  render() {
    return (h(Host, null, h("div", { class: `banner-container ${this.isShowBanner ? 'show-banner' : ''}`, ref: bannerContainer => (this.bannerContainer = bannerContainer) }, h("div", { class: "text-container" }, h("div", { class: "title-text" }, h("slot", { name: "title" })), h("div", { class: "info-text-container" }, h("span", { class: "info-text" }, h("slot", { name: "text" })), h("span", { class: "link" }, h("slot", { name: "link" })))), h("div", { class: "buttons-container" }, h("slot", { name: "accept-button" }), h("slot", { name: "reject-button" })))));
  }
  get bannerElement() { return getElement(this); }
};
CookiesBanner.style = cookiesBannerCss;

export { CookiesBanner as imv_ui_cookies_banner };
